export class Tabs {
    tabsGroups: NodeListOf<HTMLElement> = document.querySelectorAll('[data-tabs]');

    constructor() {
        if (!this.tabsGroups.length) {
            return;
        }

        this.tabsGroups.forEach((group) => this.initGroup(group));
    }

    private initGroup = (group: HTMLElement): void => {
        const tabs = Array.from(group.querySelectorAll<HTMLElement>('[data-tab-target]'));
        const panels = Array.from(group.querySelectorAll<HTMLElement>('[data-tab-panel]'));

        if (tabs.length < 2 || !panels.length) {
            return;
        }

        const initiallyActive = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ?? tabs[0];
        this.activate(group, initiallyActive, tabs, panels);

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(group, tab, tabs, panels));
            tab.addEventListener('keydown', (event) => this.handleKeydown(event, group, tab, tabs, panels));
        });
    };

    private activate = (
        group: HTMLElement,
        tab: HTMLElement,
        tabs: HTMLElement[],
        panels: HTMLElement[],
    ): void => {
        const target = tab.dataset.tabTarget;

        if (!target) {
            return;
        }

        group.dataset.activeTab = target;

        tabs.forEach((current) => {
            const isActive = current === tab;
            current.setAttribute('aria-selected', String(isActive));
            current.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel) => {
            const isActive = panel.dataset.tabPanel === target;
            panel.toggleAttribute('hidden', !isActive);
        });
    };

    private handleKeydown = (
        event: KeyboardEvent,
        group: HTMLElement,
        currentTab: HTMLElement,
        tabs: HTMLElement[],
        panels: HTMLElement[],
    ): void => {
        const currentIndex = tabs.indexOf(currentTab);
        let newIndex = currentIndex;

        switch (event.key) {
            case 'ArrowRight':
                newIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                newIndex = 0;
                break;
            case 'End':
                newIndex = tabs.length - 1;
                break;
            default:
                return;
        }

        event.preventDefault();
        const newTab = tabs[newIndex];
        newTab.focus();
        this.activate(group, newTab, tabs, panels);
    };
}
